




























































































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import TitlePatternUtility from '@utils/TitlePatternUtility'

settings =
  name: 'OmnichannelListingDetail'

  vue:
    props: ['audienceListing', 'campaign', 'activationPlan', 'actions']

    components: {
      LoadingIndicator,
    }

    computed:
      title: ->
        TitlePatternUtility.formatListingTitle @audienceListing

      addressesTags: ->
        return ['National'] if @audienceListing?.omnichannel_national
        addresses = @audienceListing?.location_list || []
        addresses.map @$options.filters.formatLocation

      omnichannelInfo: ->
        @audienceListing.omnichannel?.info || {}

      socialTableData: ->
        list = []
        if @omnichannelInfo.social?.enabled
          for type, info of @omnichannelInfo.social when info?.enabled
            list.push { type, ...info }
        list

      digitalTableData: ->
        list = []
        if @omnichannelInfo.digital?.enabled
          for type, info of @omnichannelInfo.digital when info?.enabled
            list.push { type, ...info }
        list

    methods:
      hiClose: ->
        if @actions?.close?
          @actions.close()
        else 
          @$router.push(@$route.path.split('/listings/')[0])

      hiSocialRowClick: ->
      hiSocialSelectionChange: ->

      hiDigitalRowClick: ->
      hiDigitalSelectionChange: ->

      hiRemoveFromCart: ->
        @actions.removeFromCartTrigger @audienceListing, @activationPlan.segment
        @hiClose()

      totalPriceInDollarsForType: (type) ->
        @activationPlan?.line_items_info?[0]?.addons["addon_#{type}"]?.total_price_in_dollars

export default VueOptions.vue settings
